export default __webpack_public_path__ + "static/media/icon-notif-deconnexion.e61d6f23.svg";